import { Box, Text } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './tldPrefillDescription.scss';
export const TldPrefillDescription = _ref => {
  let {
    tld
  } = _ref;
  const {
    Trans
  } = DomainSearchGateModule.internals.useTranslations();
  const extension = `.${tld}`;
  return /*#__PURE__*/React.createElement(Box, {
    paddingTop: "32px",
    width: "100%",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    align: "center",
    className: s.tldPrefillDescription
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domains_search_gate.gate_revamp.generic_site.tld_results.empty.description",
    values: {
      tld: extension
    },
    components: [/*#__PURE__*/React.createElement("b", null)]
  })));
};
//# sourceMappingURL=TldPrefillDescription.js.map